import { InInUser } from 'components/UserContext';
import { wrapCloudinary } from 'routes/Util/Util.helper';
import { useCallback } from 'react';
import './ProfilePhotoField.css';
import { useField } from 'formik';

const MAX_WIDTH = 300;
const MAX_HEIGHT = 300;

var dataURItoBlob = function (dataURI: string, type: string) {
  var bytes =
    dataURI.split(',')[0].indexOf('base64') >= 0
      ? atob(dataURI.split(',')[1])
      : unescape(dataURI.split(',')[1]);
  // var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
  var max = bytes.length;
  var ia = new Uint8Array(max);
  for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
  return new Blob([ia], { type });
};

export type ProfilePhotoProps = {
  user: InInUser;
};

export const ProfilePhotoField = ({ user }: ProfilePhotoProps) => {
  const [, meta, helpers] = useField('photoFile');
  const [field, , { setValue: setSrc }] = useField('photoURL');
  const src =
    typeof field.value === 'string' && field.value.startsWith('http')
      ? wrapCloudinary(field.value)
      : field.value;

  const onFileChange = useCallback(
    (e) => {
      const {
        target: { files },
      } = e;
      const file = files[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = function (e) {
        const { result } = e.target!;
        if (typeof result !== 'string') {
          helpers.setError('지원하지 않는 파일 형식입니다.');
          return;
        }

        const img = document.createElement('img');
        img.onload = function (event) {
          const canvas = document.createElement('canvas');

          let width = img.width;
          let height = img.height;

          // Change the resizing logic to fit the image in the canvas
          if (width > height) {
            if (width > MAX_WIDTH) {
              height = height * (MAX_WIDTH / width);
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width = width * (MAX_HEIGHT / height);
              height = MAX_HEIGHT;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d')!;
          ctx.drawImage(img, 0, 0, width, height);

          const dataurl = canvas.toDataURL(file.type);
          helpers.setError(undefined);
          helpers.setValue(dataURItoBlob(dataurl, file.type));
          setSrc(dataurl);
        };
        img.src = result;
      };
      reader.readAsDataURL(file);
    },
    [helpers, setSrc]
  );

  return (
    <div className="profile-photo d-flex flex-column align-items-center">
      <label className="profile-photo-label" htmlFor="fileElem">
        <img
          src={src}
          alt="프로필 이미지"
          width="150"
          className="border mb-3"
        />
      </label>
      <input
        id="fileElem"
        className="profile-photo-file-input"
        type="file"
        accept="image/*"
        onChange={onFileChange}
      />
      {meta.error && <small className="text-danger">{meta.error}</small>}
    </div>
  );
};
